module.exports = __webpack_public_path__ + "static/img/msg02.9b7ed47f.png";